exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".metric-results:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 8px;\n  box-shadow: inset 0px -8px 4px -4px #fff;\n  z-index: 2;\n}\n", ""]);

